module.exports = __webpack_public_path__ + "img/tablet.2de05c3e.webp";